import { Box, PropTypes } from '@mui/material';

type PropTypes = {
  isAdded: boolean;
  onClick?: () => void;
};

const AddToLibraryIcon = ({ isAdded, onClick }: PropTypes) => (
  <Box display="flex" alignItems="center" onClick={onClick}>
    {!isAdded ? (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="https://www.w3.org/2000/svg"
      >
        <g mask="url(#mask0_222_70001)">
          <path
            d="M11 21L7.825 18.15C6.625 17.0667 5.596 16.1 4.738 15.25C3.87933 14.4 3.171 13.6 2.613 12.85C2.05433 12.1 1.646 11.375 1.388 10.675C1.12933 9.975 1 9.24167 1 8.475C1 6.90833 1.525 5.604 2.575 4.562C3.625 3.52067 4.93333 3 6.5 3C7.36667 3 8.19167 3.18333 8.975 3.55C9.75833 3.91667 10.4333 4.43333 11 5.1C11.5667 4.43333 12.2417 3.91667 13.025 3.55C13.8083 3.18333 14.6333 3 15.5 3C16.85 3 17.9833 3.379 18.9 4.137C19.8167 4.89567 20.4417 5.85 20.775 7H18.65C18.35 6.33333 17.9083 5.83333 17.325 5.5C16.7417 5.16667 16.1333 5 15.5 5C14.65 5 13.9167 5.22933 13.3 5.688C12.6833 6.146 12.1083 6.75 11.575 7.5H10.425C9.90833 6.75 9.321 6.146 8.663 5.688C8.00433 5.22933 7.28333 5 6.5 5C5.55 5 4.729 5.329 4.037 5.987C3.34567 6.64567 3 7.475 3 8.475C3 9.025 3.11667 9.58333 3.35 10.15C3.58333 10.7167 4 11.371 4.6 12.113C5.2 12.8543 6.01667 13.7207 7.05 14.712C8.08333 15.704 9.4 16.9 11 18.3C11.4333 17.9167 11.9417 17.475 12.525 16.975C13.1083 16.475 13.575 16.0583 13.925 15.725L14.15 15.95L14.637 16.438L15.125 16.925L15.35 17.15C14.9833 17.4833 14.5167 17.8957 13.95 18.387C13.3833 18.879 12.8833 19.3167 12.45 19.7L11 21ZM18 17V14H15V12H18V9H20V12H23V14H20V17H18Z"
            fill="white"
          />
        </g>
      </svg>
    ) : (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="https://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_222_68808)">
          <path
            d="M18.0919 15.3791L16.7462 14.0334L15.1713 12.4585L16.5171 11.1128L18.0919 12.6876L20.9553 9.75747L22.301 11.1032L19.4377 14.0334L18.0919 15.3791ZM11.554 20.18L8.51886 17.4598C7.37352 16.429 6.39044 15.5032 5.56962 14.6919C4.7488 13.8807 4.07114 13.1171 3.5462 12.4013C3.01171 11.6854 2.62039 10.9887 2.37223 10.3206C2.12408 9.65248 2 8.95573 2 8.22081C2.00954 6.73188 2.50586 5.48156 3.50802 4.48893C4.51019 3.49631 5.76051 3 7.25899 3C8.08936 3 8.872 3.1718 9.62601 3.5154C10.3705 3.859 11.0195 4.34577 11.554 4.98524C12.098 4.34577 12.7375 3.859 13.482 3.5154C14.2264 3.1718 15.0186 3 15.849 3C17.2043 3 18.3305 3.41041 19.2468 4.23123C20.1631 5.05206 20.7262 6.0065 20.9553 7.10411C20.6689 6.98958 20.3826 6.91322 20.0963 6.85596C19.8099 6.79869 19.5331 6.77006 19.2564 6.77006C17.6529 6.77006 16.2785 7.33318 15.1522 8.44988C14.026 9.57612 13.4629 10.9314 13.4629 12.5444C13.4629 13.3748 13.6347 14.1575 13.9592 14.8924C14.2932 15.6368 14.7609 16.2668 15.3718 16.7917C15.0663 17.059 14.675 17.4121 14.1883 17.8321C13.7015 18.252 13.2815 18.6243 12.9379 18.9392L11.554 20.18V20.18Z"
            fill="#26F7C5"
          />
        </g>
        <defs>
          <clipPath id="clip0_222_68808">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
  </Box>
);

export default AddToLibraryIcon;
